import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {useCookies} from 'react-cookie';
import axios from 'axios';
import { base_url } from '../url_variables';
import { TostMessageContext } from "../context/TostMessage";
import ReactLoading from 'react-loading';
import { FaCalendarAlt, FaUser, FaSignOutAlt, FaCogs, FaSearch } from "react-icons/fa";
import { IoMdChatboxes } from "react-icons/io";
import { AiOutlineClockCircle } from "react-icons/ai";
import { HiOutlineBookOpen } from "react-icons/hi";
import { MdOutlineDashboard, MdLanguage } from "react-icons/md";
import {Button} from '@chakra-ui/react';
import { ClockLoader } from 'react-spinners';

export function ButtonSmall({onPress, label, loading}) {

  return (
        <Button onClick={onPress} className="px-[2rem] lg:px-[3rem] py-[1rem] lg:py-[1.5rem] text-dark bg-yellow rounded-[5px] text-[15px] font-bold">
            {loading ? (
                <ClockLoader
                    color={'#212121'}
                    loading={loading}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            ) : label}
        </Button>
    )
}

export function ButtonWhite({onPress, label}) {

  return (
        <Button onClick={onPress} className="bg-white text-blue-700 px-4 py-2 rounded-md font-medium text-sm">
            {label}
        </Button>
    )
}

export function ButtonBlack({onPress, label, loading}) {

  return (
        <Button onClick={onPress} className="px-[3rem] py-[1.5rem] bg-[#241D0C] text-yellow rounded-[5px] text-[15px] font-bold">
            {loading ? (
                <ClockLoader
                    color={'#F4D00F'}
                    loading={loading}
                    size={25}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                />
            ) : label}
        </Button>
    )
}
